/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/VideoReels/theme';

export const VideoReelsTheme = theme;
